import Caption from 'components/Luxkit/Typography/Caption'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import React from 'react'
import LuxPlusLogo from './Logos/LuxPlusLogo'

interface Props {
  logoHeight: number
}

function LuxPlusInsuranceLabel(props: Props) {
  const { logoHeight } = props
  return <><Caption variant="medium" weight="bold">Save up to {LUXURY_PLUS.INSURANCE_DISCOUNT_PERCENTAGE}% with </Caption><LuxPlusLogo height={logoHeight} /></>
}

export default LuxPlusInsuranceLabel
